exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.dropzone {\n    border: 1px dashed #b1b1b1;\n    border-radius: 0;\n    padding: 7px;\n}\n.dropzone .dz-message {\n    font-size: 12px;\n    margin: 50px 0;\n}\n", ""]);

// exports
